'use strict';

let mobileNav = function () {

  // Nav menu toggle
  $('.js-mobile-menu-toggle').on('click', function (event) {
    event.preventDefault();
    $(this).toggleClass('is-active');
    $('.js-nav-mobile-menu').toggleClass('is-active');
    $('html').toggleClass('no-scroll');
  });

  // Hierarchical menu item toggle
  $('.js-mobile-menu-item-toggle').on('click', function (event) {
    event.preventDefault();
    $(this).toggleClass('is-open');
    $(this).next().slideToggle(100);
  });

};

export default mobileNav;



// WEBPACK FOOTER //
// ./mobileNav.js